(() => {
  const root = document.querySelector('[data-tesevo-about]');
  if (!root) return;

  document.documentElement.setAttribute('data-tesevo-about-ready', 'true');

  const revealItems = root.querySelectorAll('[data-about-reveal]');
  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item) => revealObserver.observe(item));
  }

  const navLinks = [...root.querySelectorAll('[data-about-nav]')];
  const sections = [...root.querySelectorAll('[data-about-section]')];
  if (!navLinks.length || !sections.length) return;

  navLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      history.pushState(null, '', link.getAttribute('href'));
      const distance = Math.abs(target.getBoundingClientRect().top);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: reduceMotion || distance > window.innerHeight * 2 ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });

  if (!('IntersectionObserver' in window)) return;

  const sectionObserver = new IntersectionObserver((entries) => {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
    if (!visible) return;
    navLinks.forEach((link) => {
      const isActive = link.getAttribute('href') === `#${visible.target.id}`;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }, { rootMargin: '-30% 0px -55% 0px', threshold: [0, 0.1, 0.4] });

  sections.forEach((section) => sectionObserver.observe(section));
})();
